import { useEffect } from 'react';

import MusicPreview from '../MusicPreview/MusicPreview';

import './Music.css';

export default function Music() {
    useEffect(() => {
        const audios = document.querySelectorAll('#music .music-preview audio');

        audios.forEach((audio) => {
            audio.addEventListener('play', () => {
                audios.forEach((otherAudio) => {
                    if (otherAudio !== audio) {
                        otherAudio.pause();
                    }
                });
            });
        });
    }, []);

    return (<div id="music" className="section">
        <h1>Music</h1>

        <table>
            <tbody>
                <MusicPreview
                    title="Let Go"
                    audioFile={process.env.PUBLIC_URL + '/videos/Let Go Dec_final_02.wav'}
                    waveDataUrl={process.env.PUBLIC_URL + '/video_wave_data/Let Go Dec_final_02.json'}>
                </MusicPreview>

                <MusicPreview
                    title="Sevilla"
                    audioFile={process.env.PUBLIC_URL + '/videos/Sevilla_full_chorus.wav'}
                    waveDataUrl={process.env.PUBLIC_URL + '/video_wave_data/Sevilla_full_chorus.json'}>
                </MusicPreview>

                <MusicPreview
                    title="Tuesday"
                    audioFile={process.env.PUBLIC_URL + '/videos/Tuesday.wav'}
                    waveDataUrl={process.env.PUBLIC_URL + '/video_wave_data/Tuesday.json'}>
                </MusicPreview>

                <MusicPreview
                    title="Scarf Wearing Types"
                    audioFile={process.env.PUBLIC_URL + '/videos/Scarf_Wearing_Types_final.wav'}
                    waveDataUrl={process.env.PUBLIC_URL + '/video_wave_data/Scarf_Wearing_Types_final.json'}>
                </MusicPreview>
            </tbody>
        </table>
    </div>)
}